import {
  ClipboardList,
  LayoutDashboard,
  MonitorSmartphone,
  Building2,
  Settings,
  Users,
  Radio,
} from 'lucide-react';
import type { Permission } from '@/lib/api/types';

export interface NavItem {
  readonly to: string;
  readonly label: string;
  readonly Icon: typeof LayoutDashboard;
  /**
   * The item is shown when the technician holds at least one of these. An empty list means
   * always shown. This hides navigation the technician cannot use; it is NOT a security
   * control. docs/07-identity-rbac.md I.3: the UI is never consulted, and a hand-crafted
   * request with the same token gets exactly the same answer from the API.
   */
  readonly permissions: readonly Permission[];
  readonly description: string;
}

export const NAV_ITEMS: readonly NavItem[] = [
  {
    to: '/',
    label: 'Dashboard',
    Icon: LayoutDashboard,
    permissions: [],
    description: 'Fleet health at a glance',
  },
  {
    to: '/organizations',
    label: 'Organizations',
    Icon: Building2,
    permissions: ['organization.view'],
    description: 'Customers, sites and device groups',
  },
  {
    to: '/devices',
    label: 'Devices',
    Icon: MonitorSmartphone,
    permissions: ['device.view'],
    description: 'Every enrolled endpoint',
  },
  {
    to: '/sessions',
    label: 'Sessions',
    Icon: Radio,
    permissions: ['session.view'],
    description: 'Live and historic remote sessions',
  },
  {
    to: '/technicians',
    label: 'Technicians',
    Icon: Users,
    permissions: ['technician.view'],
    description: 'Users, roles and scoped assignments',
  },
  {
    to: '/audit',
    label: 'Audit Log',
    Icon: ClipboardList,
    permissions: ['audit.view'],
    description: 'Append-only record of every action',
  },
  {
    to: '/administration',
    label: 'Administration',
    Icon: Settings,
    permissions: ['platform.manage', 'policy.manage', 'release.manage', 'apikey.manage'],
    description: 'Tenant settings, relays and agent releases',
  },
];
